import { useEffect, useState } from "react";
import restClient from "restClients";
import CrossIcon from "assets/svg/cross-icon";
import { useDispatch } from "react-redux";
import { setShowLevel } from "store/levelSlice";
// import { useNavigate } from "react-router-dom";

function Level() {
  // const navigate = useNavigate();
  const dispatch = useDispatch();
  const [data, setData] = useState({});

  const getData = async () => {
    try {
      const { data } = await restClient.get("/level");
      if (data?.data) {
        setData(data?.data);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  useEffect(() => {
    const dismissedUntil = sessionStorage.getItem("levelBannerDismissed");
    if (dismissedUntil) {
      const currentTime = new Date().getTime();
      const expirationTime = parseInt(dismissedUntil);

      if (currentTime < expirationTime) {
        dispatch(setShowLevel(false));
        return;
      } else {
        sessionStorage.removeItem("levelBannerDismissed");
      }
    }

    getData();
  }, [dispatch]);

  const handleCrossClick = () => {
    const expirationTime = new Date().getTime() + 24 * 60 * 60 * 1000;
    sessionStorage.setItem("levelBannerDismissed", expirationTime.toString());
    dispatch(setShowLevel(false));
  };

  if (!data?.text && !data?.textMobile) {
    return null;
  }

  return (
    <div className="h-[42px] bg-pale-gold px-[12px] md:pr-[40px] py-[12px] flex items-center justify-between">
      <p className="w-full font-medium text-primary-black text-[12px] md:text-[14px] lg:text-center">
        <span className="hidden lg:inline-flex">
          {data?.text ? data?.text : data?.textMobile}
        </span>{" "}
        <span className="lg:hidden inline-flex">
          {data?.textMobile ? data?.textMobile : data?.text}
        </span>{" "}
        <span
          onClick={() => window.open(`/offers`, "_blank")}
          // onClick={() => navigate("/offers")}
          className="hover:text-secondary-rectangle-one cursor-pointer font-bold underline decoration-2 underline-offset-2 uppercase"
        >
          {data?.code}
        </span>
      </p>
      <button onClick={handleCrossClick}>
        <CrossIcon className="w-[20px] h-[20px] cursor-pointer text-pure-black shrink-0" />
      </button>
    </div>
  );
}

export default Level;
